import { render, staticRenderFns } from "./BookingFormHead.vue?vue&type=template&id=70ae887c"
import script from "./BookingFormHead.vue?vue&type=script&lang=ts"
export * from "./BookingFormHead.vue?vue&type=script&lang=ts"
import style0 from "./BookingFormHead.vue?vue&type=style&index=0&id=70ae887c&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports